export class Contact {
    contactId: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    phoneCountryCode: string;
    companyName:string;
    validPhoneNumber: boolean;
    isDefault: boolean;
    tags: string[];
    addresses: Address[];

    constructor(contact?) {
        contact = contact || {};
        this.contactId = contact.contactId || 0;
        this.firstName = contact.firstName || '';
        this.lastName = contact.lastName || '';
        this.email = contact.email || '';
        this.phoneNumber = contact.phoneNumber || '';
        this.phoneCountryCode = contact.phoneCountryCode || '+961';
        this.companyName = contact.companyName || '';
        this.tags = contact.tags || [];
        this.addresses = contact.addresses || [new Address()];
        this.validPhoneNumber = contact.validPhoneNumber || false;
        this.isDefault = contact.isDefault || false;
    }
}

export class Address {
    addressId: number;
    countryId: number;
    countryName: string;
    cityId: number;
    cityName: string;
    streetAddress1: string;
    streetAddress2: string;
    region: string;
    zipCode: string;
    display: string;

    street: string;
    building: string;
    floor: string;
    landmark: string;
    longitude: number;
    latitude: number;

    constructor(address?) {
        address = address || {};
        this.addressId = address.addressId || 0;
        this.countryId = address.countryId || 0;
        this.cityId = address.cityId || 0;

        this.countryName = address.countryName || '';
        this.cityName = address.cityName || '';
        this.streetAddress1 = address.streetAddress1 || '';
        this.streetAddress2 = address.streetAddress2 || '';
        this.region = address.region || '';
        this.zipCode = address.zipCode || '';
        this.display = address.display || '';

        this.street = address.street || '';
        this.building = address.building || '';
        this.floor = address.floor || '';
        this.landmark = address.landmark || '';
        this.longitude = address.longitude || 0;
        this.latitude = address.latitude || 0;
    }
}
